import React, { Component } from 'react';
import Button from 'components/Button';
import { PropTypes } from 'prop-types';

class RoomSelectButton extends Component {
  onSelect = () => {
    const { onClick, room } = this.props;

    onClick(room);
  };

  render() {
    const { isWaitListBooking } = this.props;

    return (
      <Button secondary onClick={this.onSelect}>
        {isWaitListBooking ? 'WAITLIST' : 'Select'}
      </Button>
    );
  }
}

RoomSelectButton.propTypes = {
  onClick: PropTypes.func,
  room: PropTypes.object,
  isWaitListBooking: PropTypes.bool
};

export default RoomSelectButton;
